// Shared sign-out button. Two visual variants:
//   - 'sidebar'     : full-width row in the dashboard nav (muted → error on hover, with icon).
//   - 'destructive' : compact destructive button used on the Account page.
// Both call useAuth().logout() and expose aria-label="Sign out".

import { LogOut } from 'lucide-react';
import { useAuth } from '@/lib/auth-context';
import { colors } from '@/lib/tokens';

export function SignOutButton({ variant }: { variant: 'sidebar' | 'destructive' }) {
  const { logout } = useAuth();

  if (variant === 'sidebar') {
    return (
      <button
        onClick={logout}
        aria-label="Sign out"
        className="flex items-center gap-3 w-full px-4 py-2.5 rounded-md text-[13px] transition-all duration-150 cursor-pointer"
        style={{ color: colors.textMuted, background: 'transparent', border: 'none' }}
        onMouseEnter={(e) => {
          (e.currentTarget as HTMLButtonElement).style.color = colors.error;
          (e.currentTarget as HTMLButtonElement).style.background = colors.errorSubtle;
        }}
        onMouseLeave={(e) => {
          (e.currentTarget as HTMLButtonElement).style.color = colors.textMuted;
          (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
        }}
      >
        <LogOut style={{ width: '15px', height: '15px', flexShrink: 0 }} />
        <span>Sign out</span>
      </button>
    );
  }

  // 'destructive'
  return (
    <button
      onClick={logout}
      aria-label="Sign out"
      className="px-4 py-2 rounded-md text-sm transition-all duration-200 cursor-pointer"
      style={{ background: colors.errorSubtle, border: `1px solid ${colors.errorBorder}`, color: colors.error }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'rgba(248,113,113,0.14)'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = colors.errorSubtle; }}
    >
      Sign out
    </button>
  );
}
